"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExecutorBase = void 0;
class ExecutorBase {
  /**
   * Create a DumbappResult for a success.
   */
  successResult(data) {
    return {
      success: true,
      data
    };
  }

  /**
   * Create a DumbappResult for a failure.
   */
  errorResult(code, message, data, submission) {
    return {
      success: false,
      code,
      message,
      errorData: data,
      submission
    };
  }

  /**
   * Create a DumbappResult for an Error object.
   */
  resultForError(err) {
    var _err$response, _err$response$data, _err$response$data$er, _err$response2, _err$response2$data, _err$response2$data$e;
    let code = ((_err$response = err.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : (_err$response$data$er = _err$response$data.error) === null || _err$response$data$er === void 0 ? void 0 : _err$response$data$er.code) || err.code || "unknown_error";
    let message = ((_err$response2 = err.response) === null || _err$response2 === void 0 ? void 0 : (_err$response2$data = _err$response2.data) === null || _err$response2$data === void 0 ? void 0 : (_err$response2$data$e = _err$response2$data.error) === null || _err$response2$data$e === void 0 ? void 0 : _err$response2$data$e.message) || err.message;
    return {
      success: false,
      code,
      message,
      errorData: err
    };
  }
}
exports.ExecutorBase = ExecutorBase;
//# sourceMappingURL=ExecutorBase.js.map